<template>
  <template v-if="!loaderPage">
    <template v-for="(item, key) in blockList" :key="`${pageSettingId}-${key}`">
      <section>
        <block-detail-wrapper
         :block-id="item._id"
         :block-type="item.type"
         v-slot="{ context }"
        >
          <suspense>
            <template #default>
              <component
               v-if="loadComponent(item.type)"
               :is="loadComponent(item.type)"
               :context="context"
               :prev-block-type="blockList[key-1] && blockList[key-1].type"
               :next-block-type="blockList[key+1] && blockList[key+1].type"
              />
            </template>
            <template #fallback>
              <skeletor-wrapper :block-type="item.type" />
            </template>
          </suspense>
          <module-ad v-if="isSG && addAd(key)" :ad-key="key" />
        </block-detail-wrapper>
      </section>
    </template>
  </template>
</template>

<script setup>
import {computed, defineAsyncComponent, onMounted } from "vue";
import {useSectionsStore} from "@/stores/section";
import {storeToRefs} from "pinia";
import {useGeneratePage} from "@/composables/useGeneratePage";
import BlockDetailWrapper from "@/components/modules/BlockDetailWrapper.vue";
import SkeletorWrapper from "@/components/skeletors/SkeletorWrapper.vue";
import {useNavigationStore} from "@/stores/navigation";

const ModuleAd = defineAsyncComponent(() => import('@/components/modules/ModuleAd.vue'))
const navigationStore = useNavigationStore()
const {loaderPage} = storeToRefs(navigationStore)

const {startLoaderPage, endLoaderPage} = navigationStore

const page = computed(() => pageSettingId.value || "SG")

const blockList = computed(() => itemsBlockPage.value[page.value]?.items)

const generatePage = useGeneratePage()

const { addAd, loadComponent } = generatePage

const sectionsStore = useSectionsStore()
const { itemsBlockPage, pageSettingId, pageSettingType } = storeToRefs(sectionsStore)
const { fetchBlockListByPage } = sectionsStore
const isSG = computed(() => pageSettingType.value === "SG")
let hiddenTime = computed(() => null)
const getMinDiff = (t1, t2) => {
  let diff = ((t2.getTime() - t1.getTime()) / 1000) / 60;
  return Math.abs(Math.round(diff));
}

const handleVisibilityChange = () => {
  if(document.hidden) {
    hiddenTime.value = new Date();
  } else if (hiddenTime.value) {
    if (getMinDiff(hiddenTime.value, new Date()) >= 5) {
      startLoaderPage()
      fetchBlockListByPage(pageSettingId.value).finally(() => {
        endLoaderPage()
      })
      hiddenTime = null;
    }
  }  
}

onMounted(() => {
  startLoaderPage()
  fetchBlockListByPage(pageSettingId.value).finally(() => {
    endLoaderPage()
  })

  if (isSG.value) {
    document.addEventListener("visibilitychange", handleVisibilityChange, false);
  }
})
</script>